import { ErrorItem } from "./ErrorItem";

export default ErrorItem;
